import { Gradient } from '@appcharge/shared-ui';

import { Offer } from 'common/contracts';

export interface IResolvedProgressBarMission {
  accumulatedItem: {
    imageUrl: string;
    backgroundColor: Gradient;
    backgroundImageUrl?: string;
  };
  barId: string;
  points: number;
}

export interface IResolveProgressBarPointsArgs {
  progressBarId: string | null | undefined;
  points: number | null | undefined;
  progressBarOffers: Offer[];
}

export const resolveProgressBarPoints = ({
  progressBarId,
  points,
  progressBarOffers
}: IResolveProgressBarPointsArgs): IResolvedProgressBarMission[] | undefined => {
  if (!progressBarId || points == null || points <= 0) {
    return undefined;
  }

  const bar = progressBarOffers.find(
    (offer: Offer): boolean => offer.offerId === progressBarId
  );
  const accumulatedItem = bar?.offerUi?.progressBar?.accumulatedItem;

  if (!accumulatedItem || !accumulatedItem.backgroundColor) {
    return undefined;
  }

  return [
    {
      barId: progressBarId,
      points,
      accumulatedItem: {
        imageUrl: accumulatedItem.imageUrl,
        backgroundColor: accumulatedItem.backgroundColor,
        backgroundImageUrl: accumulatedItem.backgroundImageUrl
      }
    }
  ];
};
